import { db } from "../../../config/firebaseconfig";
import parseSnapshot from "../../parseSnapshot";
import requestGroupUAUpdate from "../requestGroupUAUpdate";

export default function updateGUAs (userAssessments, school, schoolYear, assessmentId) {
  console.log({userAssessments, school})
  // create an array of groupUAs to update
  let GUAs = [school.district, school.id]


  // find the classes
  let classes = {}
  userAssessments.forEach(uA => {
    if (!uA.classes) return
    const keys = Object.keys(uA.classes)
    keys.forEach(key => {
      if (uA.classes[key]) {
        classes[key] = true
      }
    })
  })
  const classesIdArray = Object.keys(classes)

  // fetch the classes in the school
  db.collection('classes').where('school', '==', school.id).get()
    .then(querySnapshot => {
      // find teachers related to the classes
      let teachers = {}
      const classObjects = parseSnapshot(querySnapshot)
      classesIdArray.forEach(id => {
        if (!classObjects[id]) return
        const cl = classObjects[id]
        teachers[cl.teacher] = true
      })
      GUAs = GUAs.concat(Object.keys(teachers)).concat(classesIdArray)
      console.log('GUAs', GUAs)
      const updates = GUAs.map(GUA => {
        requestGroupUAUpdate(GUA, assessmentId, schoolYear)
          .catch(err => console.log(err))
      })
      return Promise.all(updates)
    })
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/updateGUAs.js